import { isNumber, isString } from './type-checkers'


/** @description `Intl.NumberFormat` with the style settings of 'USD currency' */
export const priceFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

/**
 * @description Using a RegEx, deletes all non-number values, including fractional seporators 
 * like commas and periods, and casts the remaining to a Number Object.
 * 
 * @param string 
 * @returns 
 */
export const toNum = (string: string) => Number(string.replace(/[^0-9]/g, '')) || 0

/**
 * @description Converts a number-like value into a Number object, formats it using the `Intl.NumberFormat` api, 
 * and returns that value with all non-number items removed. `NaN` values are returned as `0`.
 * 
 * @param value A string containing numbers or a number itself. Decimal values are handled appropriatly.
 * @returns {number}
 * 
 * @example
 * toPennies(1.5)         -> 150
 * toPennies(15)          -> 1500
 * toPennies("$15")       -> 1500
 * toPennies("$1,500.05") -> 150005
 * toPennies("1.50.0.5")  -> 0
 */
export const toPennies = (value: number | string): number => {
    const num = Number(isNumber(value) ? value : (isString(value) ? value.replace(/[,]/g, '') : 0)) || 0
    return toNum(priceFormatter.format(num))
}

/**
 * @description Similar to the css `clamp` function, ensures that a value is bound between a provided min and max.
 * 
 * @param min 
 * @param value 
 * @param max 
 * @returns 
 */
export const clamp = (min?: number, value = 0, max?: number) => {
    if (min) value = Math.max(min, value);
    if (max && (min ? max > min : true)) value = Math.min(value, max);
    return value
}